import React, { useCallback } from 'react';

import { Checkbox } from '@atlaskit/checkbox';

import { useIntl } from 'src/hooks/intl';

import { useDiffSettingsForm } from './diff-settings-form';
import messages from './i18n';

type Props = {
  isDisabled: boolean;
};

export const ColorBlindModeField = React.memo((props: Props) => {
  const intl = useIntl();
  const [formState, setFormState] = useDiffSettingsForm();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const isColorBlindModeEnabled = !!event.currentTarget.checked;
      setFormState(state => ({ ...state, isColorBlindModeEnabled }));
    },
    [setFormState]
  );

  const toggleId = 'diff-settings-color-blind-mode-toggle';

  return (
    <Checkbox
      {...props}
      label={intl.formatMessage(messages.colorAccessibilityLabelCheckbox)}
      isChecked={formState.isColorBlindModeEnabled}
      id={toggleId}
      name="enableColorBlindMode"
      onChange={handleChange}
      value="enableColorBlindMode"
    />
  );
});
